import React from "react"
import SEO from "../components/common/SEO"

import Hero from "../components/home/Hero"
import AboutPreview from "../components/home/AboutPreview"
import ServicesPreview from "../components/home/ServicesPreview"
import WhyChooseUs from "../components/home/WhyChooseUs"
import GalleryPreview from "../components/home/GalleryPreview"
import Testimonials from "../components/home/Testimonials"
import CTASection from "../components/home/CTASection"

export default function Home() {
  return (
    <>
      {/* SEO */}
      <SEO
        title="Centre Spa Land Saphir Palace Hammamet Tunisia | Détente et bien-être"
        description="Découvrez des soins spa haut de gamme, des massages, des hammams, des soins du visage et des expériences de bien-être dans un cadre luxueux."
        keywords="spa tunisien, hammam, massage spa, centre de bien-être, soins du visage tunisien"
        url="https://www.yourdomain.com/"
      />

      {/* Page Sections */}
      <main className="overflow-x-hidden">
      <Hero /> 
        <AboutPreview />
        <ServicesPreview />
        <WhyChooseUs />
        <GalleryPreview />
     {/*  <Testimonials /> */}
        <CTASection />
      </main>
    </>
  )
}